import axios from 'axios';

const AUTH_ERROR_STATUSES = new Set([401, 403]);

const PUBLIC_API_PATH_PREFIX = '/api/partners/public/';

const AUTH_FLOW_PATH_FRAGMENTS = [
  '/api/v1/login',
  '/api/v1/mfa/',
  '/api/v1/resetPassword',
  '/api/v1/updatePassword/',
  '/api/partners/v1/dashboard_users/mfa/',
];

/** MSI / venue-capability probes where 401/403 mean "not supported", not "log in again". */
export const VENUE_FEATURE_PROBE_HTTP_CONFIG = Object.freeze({
  ignoreUnauthorizedError: true,
  ignoreForbiddenError: true,
});

export function getAppOrigin() {
  return typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
}

export function normalizePathname(pathname) {
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return path.replace(/\/+$/, '') || '/';
}

export function resolveAxiosRequestUrl(config, baseOrigin = getAppOrigin()) {
  if (!config) return null;
  try {
    return new URL(axios.getUri(config), baseOrigin);
  } catch {
    return null;
  }
}

export function isSessionBackedPartnerApiRequest(config, baseOrigin = getAppOrigin()) {
  const url = resolveAxiosRequestUrl(config, baseOrigin);
  if (!url) return false;

  if (url.origin !== baseOrigin) return false;

  const path = normalizePathname(url.pathname);
  if (path !== '/api' && !path.startsWith('/api/')) return false;

  if (path.startsWith(PUBLIC_API_PATH_PREFIX)) return false;

  if (AUTH_FLOW_PATH_FRAGMENTS.some(fragment => path.includes(fragment))) return false;

  return true;
}

export function shouldRedirectToLoginForResponse(config, status) {
  if (!AUTH_ERROR_STATUSES.has(status)) return false;
  if (!isSessionBackedPartnerApiRequest(config)) return false;

  const statusString = String(status);
  if (statusString === '401' && config?.ignoreUnauthorizedError) return false;
  if (statusString === '403' && config?.ignoreForbiddenError) return false;

  return true;
}
